
import { Component, Emit, Vue, Prop } from 'nuxt-property-decorator';

const utmMedium = 'nav';
const utmCampaign = 'product-lead-gen';

@Component({})
export default class OrganizationSplashScreen extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showSplashScreen!: boolean;
  @Prop({ type: Boolean, default: false }) readonly shouldUseRouter!: boolean;
  @Prop({ type: String, required: true }) readonly illustrationPath!: string;
  @Prop({ type: String, required: true }) readonly utmSource!: 'switch-org-menu' | 'user-dropdown-menu';

  get utmReference() {
    return `?utm_source=${this.utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
  }

  get utmQuery() {
    return { utm_source: this.utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign };
  }

  @Emit()
  close() {}
}
